import { common } from "../../config/style-configs/common";

export const styles = {
  flexDirection: "column",
  ...common.loading
};
